
// import { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import './App.css';
import AppRouter from './router/AppRouter';
// import { supabase } from './supabase/client';
import { LoginContextProvider } from './context/LoginContext';

function App() {
  // const navigate = useNavigate()

  // useEffect(() => {
  //   supabase.auth.onAuthStateChange((event, session) => {
  //     !session ? navigate('/login') : navigate('/')
  //     // !session && navigate('/login')
  //   })
  // }, [navigate])

  return (
    <LoginContextProvider>
      <AppRouter />
    </LoginContextProvider>
  );
}

export default App;
